import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { Button } from "reactstrap";
import API from "utils/API";
import ReactStrapTable from "components/reactStrapTable";
import AttachIcon from "assets/icon/icon-icon-options-attachment.svg";
import AttachHoverIcon from "assets/icon/icon-icon-options-attachment_hover.svg";
import Drawer from "components/Drawer";
import Comments from "../../../../common/Comments";
import ErrorBoundary from "components/ErrorBoundary";
import HoverImage from "react-hover-image/build";
import commonColumns from "utils/columns";

let chckedIds = [];

let initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: "",
  order: "",
  filters: [],
};

const CloseMatch = ({ claimsIDsObj, claimIDs, onDataLoading, refresh }) => {
  const { patientId, tenantID } = useParams();
  const [isOpen, setOpen] = useState(false);
  const [claim, setClaim] = useState({});
  const [closeMatchClaims, setCloseMatchClaims] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [initFilter, setInitFilter] = useState(initialFilters);

  const fetchPatientDetails = async (filters = {}, hasFilter) => {
    if (hasFilter) {
      initialFilters = { ...filters };
      initialFilters.filters = filters.filters;
    } else {
      initialFilters = { ...initialFilters, ...filters };
    }
    if (claimsIDsObj.claims) {
      initialFilters.external = {
        claimIDs: [...claimIDs, ...claimsIDsObj.closeMatches],
      };
    }
    onDataLoading(true);
    try {
      const { data } = await API.post(
        `/${tenantID}/Claim/CloseMatch/${parseInt(patientId)}`,
        initialFilters
      );
      if (data) {
        setCloseMatchClaims(data.items);
        setTotalSize(data.totalRecords);
      }
      onDataLoading(false);
    } catch (error) {
      onDataLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      initialFilters = {
        currentPage: 1,
        pageSize: 10,
        orderBy: "",
        order: "",
        filters: [],
      };
    };
  });

  useEffect(() => {
    chckedIds = [];
    setCloseMatchClaims([]);
    fetchPatientDetails();
  }, [claimsIDsObj.closeMatches, claimsIDsObj.claims]);

  useEffect(() => {
    claimsIDsObj.closeMatches = [];
    claimsIDsObj.claims = [];
    chckedIds = [];
    initialFilters = {
      ...initialFilters,
      currentPage: 1,
      pageSize: 10,
      orderBy: "",
      order: "",
      filters: [],
      external: {
        claimIDs: [],
      },
    };
    setTotalSize(0);
    setInitFilter(initialFilters);
    setCloseMatchClaims([]);
  }, [refresh]);

  const toggleDrawer = (claim) => {
    setClaim(claim);
    setOpen(!isOpen);
  };

  const attachFile = (claim) => {
    return (
      <div className="d-flex align-items-center">
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => toggleDrawer(claim)}
        >
          <HoverImage src={AttachIcon} hoverSrc={AttachHoverIcon} alt="" />
        </Button>
      </div>
    );
  };

  const formatter = (row, columnName) => {
    return <>{row[columnName] || "-"}</>;
  };

  const columns = [
    {
      dataField: "attachement",
      text: "Options",
      cellRenderer: (rowData) => attachFile(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true
    },
    {
      dataField: "refRxNumber",
      text: "Ref RX #",
      headerStyle: { width: "100px" },
      show: true,
      cellRenderer: (rowData) => formatter(rowData, "refRxNumber"),
      inputType: "number",
    },
    ...commonColumns,
  ];

  const handlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      let colFilterOn = { ...filter, filters: colChangedFilter };
      setInitFilter(colFilterOn);
      fetchPatientDetails(colFilterOn, true);
    } else {
      setInitFilter(filter);
      fetchPatientDetails(filter);
    }
  };

  const handleSort = (filter, hasColFilter) => {
    setInitFilter(filter);
    if (hasColFilter) {
      fetchPatientDetails(filter, true);
    } else {
      fetchPatientDetails(filter);
    }
  };

  const handleSearchColumnFilters = (columnFilters) => {
    if (columnFilters.length) {
      let filter = {
        ...initFilter,
        filters: [...columnFilters],
        currentPage: 1,
      };
      fetchPatientDetails(filter, true);
      setInitFilter(filter);
    }
  };

  const handleFilterCancel = () => {
    initialFilters.filters = [];
    const filter = { ...initFilter, filters: [] };
    fetchPatientDetails(filter);
    setInitFilter(filter);
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      let colFilterOn = { ...filter, filters: colChangedFilter };
      setInitFilter(colFilterOn);
      fetchPatientDetails(colFilterOn, true);
    } else {
      setInitFilter(filter);
      fetchPatientDetails(filter);
    }
  };

  return (
    <div className="table-card scroll-table position-relative border-0">
      <ReactStrapTable
        id="close-match"
        height={50 * closeMatchClaims.length}
        fixedColumn
        columns={columns}
        data={closeMatchClaims}
        handleSort={handleSort}
        loader
        onSearchColumnFilters={handleSearchColumnFilters}
        onFilterCancel={handleFilterCancel}
        hasPagination
        pageSize={initFilter.pageSize}
        onPageSizeChange={onPageSizeChange}
        currentPage={initFilter.currentPage}
        totalRecords={totalSize}
        onPageChange={handlePageChange}
        filters={initFilter}
      />
      <Drawer
        direction="end"
        isOpen={isOpen}
        toggle={toggleDrawer}
        title="Claim Comments"
      >
        <ErrorBoundary>
          <Comments
            hasEditable={false}
            rxNumber={claim.rxNumber}
            onClose={toggleDrawer}
          />
        </ErrorBoundary>
      </Drawer>
    </div>
  );
};

export default CloseMatch;
